import React from 'react';
import { useSelector } from 'react-redux';
import { clientReleaseVersion } from '../../../../../../redux/slices/clientsSlice';
import { CrmUsersPageV1, CrmUsersPageV2 } from './CrmUsersPageVersion';

export default function CrmUsersPage() {
    const releaseVersion = useSelector(clientReleaseVersion);
    const versionConfig = [
        {
            component: CrmUsersPageV1,
            minVersion: null,
            maxVersion: '2.30',
        },
        {
            component: CrmUsersPageV2,
            minVersion: '2.31',
            maxVersion: null,
        },
    ];

    // Get only major and minor version
    const normalizeVersion = (version) => {
        return version?.split('.').slice(0, 2).map(Number);
    };

    const compareVersions = (releaseVer, targetVer) => {
        const splitedReleaseVer = normalizeVersion(releaseVer) || [];
        const splitedTargetVer = normalizeVersion(targetVer) || [];

        for (let i = 0; i < 2; i++) {
            // Compare semantic version (x.x)
            const semanticVerRelease = splitedReleaseVer[i] || 0;
            const semanticVerTarget = splitedTargetVer[i] || 0;
            if (semanticVerRelease > semanticVerTarget) return 1;
            if (semanticVerRelease < semanticVerTarget) return -1;
        }
        return 0;
    };

    const getComponentByVersion = (version) => {
        for (const config of versionConfig) {
            const { minVersion, maxVersion, component } = config;

            const isAfterMin = compareVersions(version, minVersion) >= 0;
            const isBeforeMax =
                !maxVersion || compareVersions(version, maxVersion) <= 0;

            if (isAfterMin && isBeforeMax) {
                return component;
            }
        }
        return () => <div>Unsupported version</div>;
    };

    // Needs to move like helper
    const Component = getComponentByVersion(releaseVersion?.version);
    return <Component />;
}
